module.exports = __webpack_public_path__ + "media/bootstrap-icons/skip-start-circle-14cfc82f.svg";